import { Filter } from './filter';

export class PageFilter extends Filter {
    page_size?: number;
    page?: number;
}
